<template>
  <div>
    <slot></slot>

    <div class="flex flex-wrap -mx-3 mb-6">
      <div class="w-full sm:w-1/2 px-3 mb-6 sm:mb-0">
        <text-input
          v-model="form.first_name"
          :readonly="readonly"
          :errors="errors ? errors.first_name : []"
          :label="$t('register.firstName')"
          :required="true"
          type="text"
          autofocus
        />
      </div>
      <div class="w-full sm:w-1/2 px-3">
        <text-input
          v-model="form.last_name"
          :readonly="readonly"
          :errors="errors ? errors.last_name : []"
          :label="$t('register.lastName')"
          :required="true"
          type="text"
        />
      </div>
    </div>

    <div class="flex flex-wrap -mx-3 mb-6">
      <div class="w-full px-3">
        <text-input
          v-model="form.email"
          :readonly="readonly"
          :errors="errors ? errors.email : []"
          :label="$t('register.email')"
          :required="true"
          type="email"
        />
      </div>
    </div>

    <div v-if="form.type === 'invoice'">
      <checkbox-input
        v-model="isCompany"
        :label="$t('shop.display-company-info')"
      />

      <div class="border-t-2 my-5" v-if="isCompany"></div>

      <div class="flex flex-wrap -mx-3 mb-6" v-if="isCompany">
        <div class="w-full sm:w-1/2 px-3 mb-6 sm:mb-0">
          <text-input
            v-model="form.company_name"
            :readonly="readonly"
            :errors="errors ? errors.company_name : []"
            :label="$t('register.companyName')"
            :required="true"
            type="text"
          />
        </div>
        <div class="w-full sm:w-1/2 px-3">
          <text-input
            v-model="form.company_registration_number"
            :readonly="readonly"
            :errors="errors ? errors.company_registration_number : []"
            :label="$t('register.companyRegistrationNumber')"
            :required="true"
            type="text"
          />
        </div>
      </div>

      <div class="flex flex-wrap -mx-3 mb-6" v-if="isCompany">
        <div class="w-full sm:w-1/2 px-3 mb-6 sm:mb-0">
          <text-input
            v-model="form.company_industry"
            :readonly="readonly"
            :errors="errors ? errors.company_industry : []"
            :label="$t('register.industry')"
            type="text"
          />
        </div>
        <div class="w-full sm:w-1/2 px-3">
          <text-input
            v-model="form.company_position"
            :readonly="readonly"
            :errors="errors ? errors.company_position : []"
            :label="$t('register.position')"
            type="text"
          />
        </div>
      </div>

      <div class="border-t-2 my-5"></div>
    </div>

    <div class="flex flex-wrap -mx-3 mb-6">
      <div class="flex flex-wrap -mx-1 sm:mb-6">
        <div class="w-full sm:w-1/4 px-3 mb-6 sm:mb-0">
          <country-select
            :readonly="readonly"
            :errors="errors ? errors.country_code : []"
            v-model="form.country_code"
            :required="true"
          />
        </div>

        <div
          class="w-full sm:w-1/4 px-3 mb-6 sm:mb-0"
          v-if="form.country_code === 'RO'"
        >
          <select-input
            v-model="form.county"
            @input="rerfeshCities()"
            :readonly="readonly"
            :errors="errors ? errors.county : []"
            :label="$t('register.county')"
            :required="true"
            class="select_adress"
          >
            <option value="">Select</option>

            <option
              v-for="county in counties"
              :key="county.judet_id"
              :value="county.nume"
            >
              {{ county.nume }}
            </option>
          </select-input>
        </div>

        <div
          class="w-full sm:w-1/4 px-3 mb-6 sm:mb-0"
          v-if="form.country_code !== 'RO'"
        >
          <text-input
            v-model="form.city"
            :readonly="readonly"
            :errors="errors ? errors.city : []"
            :label="$t('register.city')"
            :required="true"
            type="text"
          />
        </div>

        <div
          class="w-full sm:w-1/4 px-3 mb-6 sm:mb-0"
          v-if="form.country_code === 'RO'"
        >
          <select-input
            v-model="form.city"
            :errors="errors.city"
            :label="$t('register.city')"
            autofocus
          >
            <option
              v-for="(city, index) in cities"
              :key="index"
              :value="city.nume"
            >
              {{ city.nume }}
            </option>
          </select-input>
        </div>

        <div class="w-full sm:w-1/4 px-3 mb-6 sm:mb-0">
          <text-input
            v-model="form.postcode"
            :readonly="readonly"
            :errors="errors ? errors.postcode : []"
            :label="$t('register.postalCode')"
            :required="true"
            type="text"
          />
        </div>
      </div>

      <div class="w-full px-3">
        <text-input
          v-model="form.address"
          :readonly="readonly"
          :errors="errors ? errors.address : []"
          :label="$t('register.address')"
          :required="true"
          type="text"
        />
      </div>
    </div>

    <div class="flex flex-wrap -mx-3 mb-6">
      <div class="w-full px-3">
        <text-input
          v-model="form.phone_number"
          :readonly="readonly"
          :errors="errors ? errors.phone_number : []"
          :label="$t('register.phoneNumber')"
          :required="true"
          type="number" placeholder="07xxxxxxxx"
        />
      </div>
    </div>

    <div class="mb-6">
      <slot name="nocaptcha"></slot>
      <div
        v-if="errors['g-recaptcha-response']"
        class="text-red-500 text-sm mt-2"
      >
        {{ errors["g-recaptcha-response"] }}
      </div>
    </div>

    <div class="flex flex-wrap -mx-3 mb-6" v-if="form.type === 'invoice'">
      <div class="w-full px-3">
        <checkbox-input
          v-model="billingIsShipping"
          :label="$t('shop.billing-address-is-shipping-address')"
        />
      </div>
    </div>

    <div class="sm:flex sm:items-center sm:justify-between">
      <button
        @click="saveContact()"
        type="submit"
        class="
          block
          sm:flex sm:items-center
          px-4
          py-3
          rounded
          font-bold
          text-sm
          cursor-pointer
          bg-green-500
          text-white
          hover:bg-green-400
          text-center
          w-full
          sm:w-auto sm:order-last
        "
      >
        {{ $t("common.next") }}
      </button>
      <div class="text-center text-sm text-gray-500 mt-2 sm:mt-0 sm:text-left">
        {{ $t("shop.not-charget-yet") }}
      </div>
    </div>
  </div>
</template>


<script>
import TextInput from "@/Shared/TextInput";
import CheckboxInput from "@/Shared/CheckboxInput";
import CountrySelect from "@/Shared/Forms/CountrySelect";
import axios from "axios";
import SelectInput from "@/Shared/SelectInput";

export default {
  components: {
    TextInput,
    CheckboxInput,
    CountrySelect,
    SelectInput,
  },
  props: {
    contact: Object,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.form.type === "invoice") {
      if (this.form.company_name || this.form.company_registration_number) {
        this.isCompany = true;
      }
      if (typeof this.form.county === "undefined") {
        this.form.county = "";
      }

      // window.onloadInvoiceContactCaptchaCallback();
      if (document.getElementById("g-recaptcha-response")) {
        // document.getElementById('g-recaptcha-response').value = '';
      }
    }
    this.citiesCache = [];
    this.populateCities();
  },
  data() {
    return {
      isCompany: false,
      form: this.contact,
      errors: {},
      processing: false,
      billingIsShipping: false,
      cities: [],
      counties: [
        { judet_id: 1, nume: "Alba" },
        { judet_id: 2, nume: "Arad" },
        { judet_id: 3, nume: "Arges" },
        { judet_id: 4, nume: "Bacau" },
        { judet_id: 5, nume: "Bihor" },
        { judet_id: 6, nume: "Bistrita-Nasaud" },
        { judet_id: 7, nume: "Botosani" },
        { judet_id: 8, nume: "Braila" },
        { judet_id: 9, nume: "Brasov" },
        { judet_id: 10, nume: "Bucuresti" },
        { judet_id: 11, nume: "Buzau" },
        { judet_id: 12, nume: "Calarasi" },
        { judet_id: 13, nume: "Caras-Severin" },
        { judet_id: 14, nume: "Cluj" },
        { judet_id: 15, nume: "Constanta" },
        { judet_id: 16, nume: "Covasna" },
        { judet_id: 17, nume: "Dambovita" },
        { judet_id: 18, nume: "Dolj" },
        { judet_id: 19, nume: "Galati" },
        { judet_id: 20, nume: "Giurgiu" },
        { judet_id: 21, nume: "Gorj" },
        { judet_id: 22, nume: "Harghita" },
        { judet_id: 23, nume: "Hunedoara" },
        { judet_id: 24, nume: "Ialomita" },
        { judet_id: 25, nume: "Iasi" },
        { judet_id: 26, nume: "Maramures" },
        { judet_id: 27, nume: "Mehedinti" },
        { judet_id: 28, nume: "Mures" },
        { judet_id: 29, nume: "Neamt" },
        { judet_id: 30, nume: "Olt" },
        { judet_id: 31, nume: "Prahova" },
        { judet_id: 32, nume: "Salaj" },
        { judet_id: 33, nume: "Satu Mare" },
        { judet_id: 34, nume: "Sibiu" },
        { judet_id: 35, nume: "Suceava" },
        { judet_id: 36, nume: "Teleorman" },
        { judet_id: 37, nume: "Timis" },
        { judet_id: 38, nume: "Tulcea" },
        { judet_id: 39, nume: "Valcea" },
        { judet_id: 40, nume: "Vaslui" },
        { judet_id: 41, nume: "Vrancea" },
        { judet_id: 206, nume: "Ilfov" },
      ],
      citiesCache: [],
    };
  },
  methods: {
    async saveContact() {
      var component = this;
      component.errors = {};
      this.processing = true;
      component.errors = {};

      if (document.getElementById("g-recaptcha-response")) {
        component.form["g-recaptcha-response"] = document.getElementById(
          "g-recaptcha-response"
        ).value;
      }

      if (!component.isCompany) {
        component.form.company_name = "";
        component.form.company_registration_number = "";
        component.form.company_industry = "";
        component.form.company_position = "";
      }

      let data = {
        contact: component.form,
      };

      //let url = this.route("platform.shop.checkout.save-billing-info");
      var url = "";
      if (component.form.type === "invoice") {
        url = "/shop/save-billing-info";
        data.contact.billingIsShipping = this.billingIsShipping;
      }

      if (component.form.type === "shipping") {
        url = "/shop/save-shipping-info";
      }

      await axios({
        method: "post",
        url: url,
        data: data.contact,
      }).then(
        (response) => {
          //success
          this.$toastr.s("", this.$t("common.data-saved"));
          this.$emit("step-change", response.data);
        },
        (error) => {
          //fail / invaild data
          let toasted = false;
          if (typeof error.response !== "undefined") {
            if (error.response.data) {
              if (error.response.data.errors) {
                component.errors = error.response.data.errors;
                if(error.response.data.errors.company_name || error.response.data.errors.company_registration_number){
                  this.isCompany = true; //automatically display company info
                }
              }

              if (error.response.data.message) {
                toasted = true;
                this.$toastr.e(
                  error.response.data.message,
                  this.$t("common.save-error-title")
                );
              }

              
              
            }
          }
          if (!toasted) {
            this.$toastr.e(error.message, this.$t("common.save-error-title"));
          }
        }
      );

      this.processing = false;
    },

    //https://www.selfawb.ro/new/api/getExternalKm post {localitateId: 33}
    /*
    async getAgencies() {//ridicare personala
      var component = this;
      component.errors = {};
      this.processing = true;
      component.errors = {};


      let data = {
        countyId: 25,
        localityId: 33,
        mapType: recipient
      };

      var url = "";

      if (component.form.type === "shipping") {
        url = "https://www.selfawb.ro/new/awb/load-map";
      }

      await axios({
        method: "post",
        url: url,
        data: data.contact,
      }).then(
        (response) => {
          //success
          this.$emit("step-change", response.data);//
        },
        (error) => {
          //fail / invaild data
          let toasted = false;
          if (typeof error.response !== "undefined") {
            if (error.response.data) {
              if (error.response.data.errors) {
                component.errors = error.response.data.errors;
              }

              if (error.response.data.message) {
                toasted = true;
                this.$toastr.e(
                  error.response.data.message,
                  this.$t("common.save-error-title")
                );
              }
            }
          }
          if (!toasted) {
            this.$toastr.e(error.message, this.$t("common.save-error-title"));
          }
        }
      );

      this.processing = false;
    },
    */
    getCountyId(countyName) {
      var judetId = false;
      for (var i = 0; i < this.counties.length; i++) {
        if (this.counties[i].nume == countyName) {
          judetId = this.counties[i].judet_id;
          break;
        }
      }
      return judetId;
    },
    rerfeshCities() {
      this.form.city = "";
      this.form.postcode = "";
      this.populateCities();
    },
    async populateCities() {
      this.cities = [];

      if (this.form.county) {
        let countyId = this.getCountyId(this.form.county);

        if (!Number.isInteger(countyId)) {
          return;
        }

        if (this.citiesCache[countyId]) {
          this.cities = this.citiesCache[countyId];
          return;
        }

        await axios({
          method: "get",
          url: "https://www.selfawb.ro/new/api/city/" + countyId,
        }).then(
          (response) => {
            //success
            this.cities = response.data;
            this.citiesCache[countyId] = response.data;
          },
          (error) => {
            if (typeof error.response !== "undefined") {
              if (error.response.data) {
                if (error.response.data.errors) {
                  // component.errors = error.response.data.errors;
                  console.error(error.response.data.errors);
                }

                if (error.response.data.message) {
                  console.error(error.response.data.message);
                }
              }
            }
            this.$toastr.e(error.message, this.$t("common.save-error-title"));
          }
        );
      }
    },
    setForm(contact) {
      this.form = contact;
    },
  },
};
</script>
